import { z } from 'zod';

import { EquipmentTableColumns } from '@/features/equipment/-query/selector';

export const EquipmentSearchSchema = z.object({
  sortColumn: z.nativeEnum(EquipmentTableColumns).optional(),
  sortOrder: z.enum(['asc', 'desc']).default('asc'),
  freeText: z.string().optional(),
  page: z.number().min(1).default(1),
  pageSize: z.number().min(1).default(100),
});
